import $ from 'jquery';
import _ from 'lodash';
import { DropdownCalendar } from '../common/DropDownCalendar';
import { util } from '../common/util';
import { ui } from '../common/ui';
import { split } from './split';
import { places } from './places';
import { client } from './client_v2';
import { messageUtility } from '../../utilities/messageUtility';
import { userinfo } from '../common/userinfo';

function _printPdf() {
  this.init = function() {
    var self = this;
    self.dropdownCalendarFrom = new DropdownCalendar();
    self.dropdownCalendarFrom.init(
      'dropdown-calendar-print-from',
      'input[name=date_from]',
      userinfo.getFieldId()
    );
    self.dropdownCalendarTo = new DropdownCalendar();
    self.dropdownCalendarTo.init(
      'dropdown-calendar-print-to',
      'input[name=date_to]',
      userinfo.getFieldId()
    );
    $('input[name=sys_check_all]').change(function() {
      let self = this;
      _.each($('.print-place-table .place-check'), function(placeCheck) {
        $(placeCheck).prop('checked', $(self).prop('checked'));
      });
    });

    // ツールバー 印刷 ボタン
    /** @description ポップアップ処理が動作する */
    $('.toolbar-canvas-copy-popup').click(function() {
      if (split._splitNumber > 1) {
        self.printSplitPdf(split._splitNumber);
      } else {
        self.setPrintList();
        $('#modal-dialog-print').addClass('show');
        $(this).addClass('selected');
      }
    });
    // 印刷ダイアログ 戻る ボタン
    $('#modal-dialog-print .sys_cancel').click(function() {
      $('#modal-dialog-print').removeClass('show');
      $('.toolbar-canvas-copy-popup').removeClass('selected');
    });
    // 印刷ダイアログ 印刷 ボタン
    $('#modal-dialog-print .sys_print').on('click', function() {
      self.printPdf();
      $('.toolbar-canvas-copy-popup').removeClass('selected');
    });
  };

  this.setPrintList = function() {
    $('input[name=date_from]').val(
      util.dataFormat(ui.currentDate, 'YYYY/MM/DD')
    );
    $('input[name=date_to]').val(util.dataFormat(ui.currentDate, 'YYYY/MM/DD'));
    let placeList = places._placeList;
    $('input[name=sys_check_all]').prop('checked', false);
    $('.print-place-table tbody').html('');
    _.each(placeList, function(place) {
      let checked = places._selectId == place.id ? 'checked' : '';
      let tr =
        `${'' +
          '<tr class="table__item">' +
          '<td class="value-table">' +
          '<div class="value-table__icon">' +
          '<div class="btn-radio-mini">' +
          '<label for="place-'}${place.id}" class="checkbox">` +
        `<input id="place-${place.id}" type="radio" value="${
          place.id
        }" data-name="${_.escape(place.name)}" class="place-check" ` +
        ` name="place"${checked} />` +
        `</label>` +
        `</div>` +
        `</div>` +
        `</td>` +
        `<td class="value-table">` +
        `<div class="value-table__name">${_.escape(place.name)}</div>` +
        `</td>` +
        `</tr>`;
      $('.print-place-table tbody').append(tr);
    });
  };

  this.printPdf = function() {
    let startDate = $('input[name=date_from]').val();
    let endDate = $('input[name=date_to]').val();
    if (startDate == '') {
      // 開始日を指定してください
      ui.showPopupMessage(messageUtility.getMessage('E-001-355'));
      return;
    }
    if (endDate == '') {
      // 終了日を指定してください
      ui.showPopupMessage(messageUtility.getMessage('E-001-356'));
      return;
    }
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    if (endDate < startDate) {
      // 終了日は開始日より前に指定してください
      ui.showPopupMessage(messageUtility.getMessage('E-001-357'));
      return;
    }
    let getDateList = function(start, end) {
      let dateList = [];
      while (start <= end) {
        dateList.push(new Date(start));
        start.setDate(start.getDate() + 1);
      }
      return dateList;
    };
    let dateList = getDateList(startDate, endDate);
    if (dateList.length > 31) {
      // 印刷対象期間は1か月以内になるように指定してください
      ui.showPopupMessage(messageUtility.getMessage('E-001-358'));
      return;
    }
    let roomIds = [];
    let printTimeFlags = [];
    let dates = [];
    let places = [];
    _.each(dateList, function(date) {
      _.each($('.print-place-table .place-check:checked'), function(
        placeCheck
      ) {
        let roomId = util.getRoomId($(placeCheck).val(), date);
        roomIds.push(roomId);
        printTimeFlags.push('1');
        dates.push(util.dataFormat(date, 'YYYY年MM月DD日(WW)'));
        places.push($(placeCheck).attr('data-name'));
      });
    });
    if (roomIds.length === 0) {
      ui.showPopupMessage('対象を選択してください');
    } else {
      $('#modal-dialog-print .sys_print').prop('disabled', true);
      client.getPdf({
        roomIds,
        printTimeFlags,
        dates,
        places,
      });
      // $('#modal-dialog-print').removeClass('show');
    }
  };

  this.printSplitPdf = function(num) {
    var roomIds = [];
    var dates = [];
    var places = [];
    for (let i = 0; i < num; i++) {
      roomIds.push(split._splitRoomIds[i]);
      let date = $(`.sys_cell_${i}`)
        .find('input[name=split_view_date]')
        .val();
      let place = $(`.sys_cell_${i}`)
        .find('input[name=split_view_place]')
        .val();
      dates.push(util.dataFormat(new Date(date), 'YYYY年MM月DD日(WW)'));
      places.push(place);
    }
    $('.toolbar-canvas-copy-popup').prop('disabled', true);
    client.getSplitPdf({
      roomIds,
      dates,
      places,
      splitNum: num,
    });
  };
}

export const printPdf = new _printPdf();



// WEBPACK FOOTER //
// ./src/canvas/constructionPlacement/print.js